import {Box, IconButton, Typography} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import type {ReactNode} from 'react';
import React from 'react';

export interface ModalHeaderProps {
    /** Icon-Glyph, wird weiß in der roten Box gerendert */
    icon?: ReactNode;
    /** kleine Zeile über dem Titel, z. B. "Reservierung" */
    eyebrow?: ReactNode;
    title: ReactNode;
    /** optionaler Status-Chip rechts (z. B. <StatusChip … />) */
    status?: ReactNode;
    onClose?: () => void;
}

export function ModalHeader({icon, eyebrow, title, status, onClose}: ModalHeaderProps) {
    return (
        <Box sx={{display: 'flex', alignItems: 'center', gap: 1.5, px: 2.75, py: 2}}>
            {icon && (
                <Box
                    sx={{
                        width: 34,
                        height: 30,
                        flex: '0 0 auto',
                        bgcolor: 'error.main',
                        color: 'common.white',
                        borderRadius: 1.5,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        '& svg': {fontSize: 20},
                    }}
                >
                    {icon}
                </Box>
            )}

            <Box sx={{flex: 1, minWidth: 0}}>
                {eyebrow && (
                    <Typography variant="caption" color="text.secondary" sx={{display: 'block', lineHeight: 1.2}}>
                        {eyebrow}
                    </Typography>
                )}
                <Typography
                    sx={{fontSize: 19, fontWeight: 600, lineHeight: 1.25, fontVariantNumeric: 'tabular-nums'}}
                >
                    {title}
                </Typography>
            </Box>

            {status}

            {onClose && (
                <IconButton onClick={onClose} size="small" aria-label="Schließen" sx={{color: 'action.active'}}>
                    <CloseIcon/>
                </IconButton>
            )}
        </Box>
    );
}